import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyANpeMZZn92miyIpS6iBEq22D_-mu3eAH0",
    authDomain: "hyyyl-39c27.firebaseapp.com",
    projectId: "hyyyl-39c27",
    storageBucket: "hyyyl-39c27.appspot.com",
    messagingSenderId: "153515941699",
    appId: "1:153515941699:web:b4d92265aaff9b8ff719f6",
    measurementId: "G-KNMPH0HGWH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
